import type { TDocumentType } from 'api/swagger';

export enum EDocumentSearchField {
  userId = 'userId',
  clientId = 'clientId',
  orderId = 'orderId',
  cargoId = 'cargoId',
  tripId = 'tripId',
  invoiceId = 'invoiceId',
  warehouseTaskId = 'warehouseTaskId',
  expenseId = 'expenseId',
}

export const DocumentType: Record<TDocumentType, string> = {
  cmr: 'CMR',
  cds: 'CDS',
  ex1: 'EX-1',
  barcode: 'Barcode',
  t1: 'T-1',
  ens: 'ENS',
  gmr: 'GMR',
  elo: 'ELO',
  deliveryNote: 'Delivery note',
  invoice: 'Invoice',
  cargoPhoto: 'Cargo photo',
  packingList: 'Packing list',
  order: 'Order',
  none: 'Other',
};
